import React, {useEffect, useState} from 'react';
import {Quiz} from "types/Quiz";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";

type Props = {
    quiz: Quiz | null
    show: boolean
    onDelete?: (quiz: Quiz) => any
    onDeleteFail?: (quiz: Quiz, error: unknown) => any
    onCancel?: () => any
}

function DeleteQuiz(props: Props) {
    const {quiz, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(quiz?.title || 'this quiz');
    const {mutateAsync: deleteQuiz} = useMutation(ngage.quizzes.destroy)

    useEffect(() => {
        if(quiz) setName(quiz.title)
    }, [quiz]);

    async function handleDeleteQuiz() {
        if (quiz) {
            try {
                await deleteQuiz(quiz.id)
                await invalidate('quizzes.all')

                if (onDelete) onDelete(quiz)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(quiz, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Quiz"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteQuiz}
            onCancel={handleCancel}
        />
    );
}

export default DeleteQuiz;